
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff"}},[_c('path',{attrs:{"d":"M10.667 11.333V8.667a2.667 2.667 0 00-5.334 0v2.666a2.667 2.667 0 105.334 0zM8 4.667a4 4 0 00-4 4v2.666a4 4 0 108 0V8.667a4 4 0 00-4-4z"}}),_c('path',{attrs:{"d":"M8 .667A2.667 2.667 0 108 6 2.667 2.667 0 008 .667zm0 4A1.333 1.333 0 118 2a1.333 1.333 0 010 2.667zM1.254.005a.667.667 0 01.741.583c.074.613.346 1.626.922 2.582.572.95 1.417 1.802 2.623 2.196a.667.667 0 11-.414 1.268c-1.593-.52-2.665-1.637-3.351-2.776C1.092 2.726.765 1.528.67.746a.667.667 0 01.583-.741zM15.412 15.995a.667.667 0 01-.74-.583c-.074-.614-.346-1.626-.922-2.582-.572-.95-1.417-1.802-2.624-2.196a.667.667 0 01.414-1.268c1.594.52 2.666 1.637 3.352 2.776.682 1.133 1.01 2.33 1.103 3.112a.666.666 0 01-.583.741zM.687 7.172a.667.667 0 01.808-.485l2.667.666a.667.667 0 11-.324 1.294L1.172 7.98a.667.667 0 01-.485-.808zM15.313 7.172a.667.667 0 00-.808-.485l-2.667.666a.667.667 0 10.324 1.294l2.666-.667a.667.667 0 00.485-.808zM14.746.005a.667.667 0 00-.741.583c-.074.613-.346 1.626-.922 2.582-.572.95-1.417 1.802-2.623 2.196a.667.667 0 00.413 1.268c1.594-.52 2.666-1.637 3.352-2.776.683-1.132 1.01-2.33 1.104-3.112a.667.667 0 00-.583-.741zM.588 15.995a.667.667 0 00.74-.583c.074-.614.346-1.626.922-2.582.572-.95 1.417-1.802 2.624-2.196a.667.667 0 00-.414-1.268c-1.594.52-2.666 1.637-3.352 2.776-.682 1.133-1.01 2.33-1.103 3.112a.667.667 0 00.583.741zM8 9.333c.368 0 .667.299.667.667v4.667a.667.667 0 01-1.334 0V10c0-.368.299-.667.667-.667z"}})])])
          )
        }
      }
    